<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-05-21 18:50:41
 * @LastEditTime: 2019-08-12 16:04:11
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div>
    <el-form :inline="true">
      <el-form-item v-if="isVisible('type')">
        <el-select v-model="type" @change="changeType">
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="isVisible('type') && type === 'appId'">
        <el-select v-model="appId" placeholder="请选择媒体" clearable filterable @change="changeAppId">
          <el-option
            v-for="item in appIdOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="isVisible('type') && type === 'pageId'">
        <el-select v-model="pageId" placeholder="请选择页面" clearable filterable @change="changePageId">
          <el-option
            v-for="item in pageIdOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="isVisible('type') && type === 'slotId'">
        <el-select v-model="slotId" placeholder="请选择广告位" clearable filterable @change="changeSlotId">
          <el-option
            v-for="item in slotIdOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-radio-group v-model="dateRange" @change="changeDateRange">
          <el-radio-button :label="0.5">30分钟</el-radio-button>
          <el-radio-button :label="1">1小时</el-radio-button>
          <el-radio-button :label="3">3小时</el-radio-button>
          <el-radio-button :label="6">6小时</el-radio-button>
          <el-radio-button :label="12">12小时</el-radio-button>
          <el-radio-button :label="24">1天</el-radio-button>
          <el-radio-button :label="48">2天</el-radio-button>
          <el-radio-button :label="72">3天</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="showCharts">刷新</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import mixins from './mixins.js';

export default {
  mixins: [mixins],
  props: ['showCharts', 'defaultDateRange'],
  data() {
    return {
      dateOptions: [
        {
          label: '30分钟',
          value: 0.5
        },
        {
          label: '1小时',
          value: 1
        },
        {
          label: '3小时',
          value: 3
        },
        {
          label: '6小时',
          value: 6
        },
        {
          label: '12小时',
          value: 12
        },
        {
          label: '1天',
          value: 24
        },
        {
          label: '2天',
          value: 48
        },
        {
          label: '3天',
          value: 72
        }
      ],
      dateRange: ''
    };
  },
  created() {
    this.dateRange = this.defaultDateRange || this.dateOptions[0].value;
  },
  methods: {
    init() {
      this.$emit('update:params', {
        clientType: this.clientType,
        dateRange: this.dateRange,
        type: this.type,
        [this.type]: this[this.type]
      });
      this.showCharts();
    },
    changeDateRange(dateRange) {
      this.$emit('update:params', {
        clientType: this.clientType,
        dateRange,
        type: this.type,
        [this.type]: this[this.type]
      });
      this.showCharts();
    }
  }
}
</script>
